export default function getAllLoadsFiles(loads, tripId) {
	const result = [];

	if (!Array.isArray(loads)) {
		return result;
	}

	for (let i = 0; i < loads.length; i++) {
		const load = loads[i];
		if (!load) continue;

		let files = [];
		if (Array.isArray(load.file)) files = load.file;
		if (!files.length) continue;

		let loadId = null;
		if (load.load_id != null) loadId = load.load_id;

		for (let j = 0; j < files.length; j++) {
			const f = files[j];
			if (!f) continue;

			result.push({
				trip_id: tripId != null ? tripId : null,
				load_id: f.load_id != null ? f.load_id : loadId,

				created_at: f.created_at || null,
				description: f.description || null,
				dispatcher_name: f.dispatcher_name || null,
				file: f.image || null,
				typeName: f.typeName || null
			});
		}
	}

	return result;
}
